// extracted by mini-css-extract-plugin
module.exports = {"checkoutPricePage":"CheckoutPricePage_checkoutPricePage__34QHh","checkoutPriceBlock":"CheckoutPricePage_checkoutPriceBlock__2FDME"};